const announcement = {

	init() {
		document.querySelectorAll('.announcement').forEach( function( element ) {
			let cookieid = element.id;
			let modtime  = element.dataset.modtime;
			let message = document.querySelector('.br-toggle');
			message.toggle = Object.assign(new BRToggle(message, { accordion: false, open: false }));
			if (Cookies.get(cookieid) === undefined) {
				Cookies.set(cookieid, modtime, { expires: 1 });
				// Cookies.set(cookieid, modtime, { expires: 1, Secure: true, HttpOnly: true });
				message.toggle.open(0);
			} else if (Cookies.get(cookieid) !== undefined && Cookies.get(cookieid) !== modtime) {
				Cookies.set(cookieid, modtime, { expires: 1 });
				// Cookies.set(cookieid, modtime, { expires: 1, Secure: true, HttpOnly: true });
				message.toggle.open(0);
			}
		});		
	}
	
};

export { announcement };
